import styled from "styled-components";
const fontSize = localStorage.getItem("fontSize");
interface Props {
  flexDirection: string;
}

export const Title = styled.span`
  font-family: "Segoe UI";
  font-style: normal;
  font-weight: 700;
  font-size: calc(${fontSize} + 2.125rem);
  color: #101e8e;
  text-align: center;
`;

export const HomeLayoutRoot = styled("div")(({ theme }) => ({
  display: "flex",
  flex: "1 1 auto",
  maxWidth: "100%",
  paddingTop: 64,
  // [theme.breakpoints.up('lg')]: {
  //   paddingLeft: 280
  // }
}));

export const NewsCardsContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
  margin-bottom: 3rem;
  @media (width<=768px) {
    flex-direction: column;
    gap: 2rem;
  }
`;

export const NewsCard = styled.div`
  display: flex;
  flex-direction: ${(props: Props) => props.flexDirection};
  height: 260px;
  align-items: flex-start;
  justify-content: center;
  gap: 0;
  width: 327px;
  font-size: 1.2rem;
  div {
    margin: 0;
  }
  img {
    width: 100%;
  }
  @media (max-width: 768px) {
    width: 90%;
  }
`;

export const CardData = styled.div`
  background: #fff;
  color: #101e8e;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1.5rem;
  section {
    align-self: flex-end;
    height: 100%;
    display: flex;
    align-items: flex-end;
    width: 100%;
    justify-content: space-between;
    font-weight: bold;
    span {
      display: flex;
      align-items: center;
    }
    button {
      width: 4.5rem;
      height: 2rem;
      padding: 0.3rem;
      background: #d8daed;
      font-size: 0.8rem;
      font-weight: bold;
      color: 11ee1e;
    }
  }
  @media (max-width: 768px) {
    height: 60%;
    width: 100% !important;
  }
`;

export const NewsLeftCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 60%;
  height: 520px;
  margin-bottom: 1rem;
`;
